import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { useSelector } from "react-redux";

import {
  formatDateBySetting,
  convertValuesFM,
  getResponse,
  converDateFormatForPicker,
} from "../../../shared-resources/utils";

const useStyles = makeStyles({
  table: {
    width: "96%",
    border: "1px solid #000",
  },
  tableTitle: {
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#01539a",
    lineHeight: "1",
  },
  tableRow: {
    height: 30, // Adjust row height here
  },
  tableCell: {
    padding: "4px 8px", // Reduce padding
    lineHeight: "1.2", // Adjust line height to control text positioning
    verticalAlign: "bottom", // Position text at the bottom
  },
});

const costPointColumnDefs = [
  { key: "businessUnit", display: "Business Unit", type: "text" },
  { key: "customerName", display: "Customer", type: "text" },
  { key: "projectManager", display: "Project Manager", type: "text" },
  { key: "popStartDate", display: "POP Start Date", type: "date" },
  { key: "popEndDate", display: "POP End Date", type: "date" },
  { key: "primeContractId", display: "Prime Contract ID", type: "text" },
  { key: "contractType", display: "Contract Type", type: "text" },
  {
    key: "projectFundingCognus",
    display: "Project Funding Cognus",
    type: "currency",
  },
  {
    key: "projectTotalValue",
    display: "Project Total Value",
    type: "currency",
  },
];

export default function Costpoint() {
  const classes = useStyles();

  const [dateFormat, setDateFormat] = useState("DD/MM/YYYY");

  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData,
  );

  const contractSummaryData = useSelector(
    (state) => state.financialManagementReducer.contractSummaryData,
  );

  useEffect(() => {
    if (getResponse(generalSettingsData, []).length > 0) {
      setDateFormat(
        converDateFormatForPicker(
          getResponse(generalSettingsData, [])[0].date_format,
        ),
      );
    }
  }, [generalSettingsData]);

  const formatData = (value, type) => {
    if (value) {
      if (type === "date")
        return formatDateBySetting(
          new Date(value.replace(/-/g, "/")),
          dateFormat,
        );
      if (type === "currency") return `${convertValuesFM(value)}`;
      return value;
    }
    return "";
  };

  const bindTableData = () => {
    const data = contractSummaryData.data;
    return (
      <>
        {costPointColumnDefs.map((val, i) => (
          <TableRow key={i} className={classes.tableRow}>
            <TableCell
              component="th"
              scope="row"
              className={classes.tableCell}
              style={{ width: "200px" }}
            >
              {val.display}
            </TableCell>
            <TableCell
              className={classes.tableCell}
              title={formatData(data[val.key], val.type)}
            >
              {formatData(data[val.key], val.type)}
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <TableContainer>
      <Table
        className="contractSummaryTable"
        aria-label="simple table"
        style={{ width: "96%" }}
      >
        <TableHead>
          <TableRow className={classes.tableTitle}>
            <TableCell colSpan={2} className={classes.tableTitle}>
              Project Information from Cost Point
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contractSummaryData &&
            contractSummaryData.status === 200 &&
            bindTableData()}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
